import React, { useState, useEffect } from 'react';

import FURGAPI from '../../../services/api.furg';
import Preview from './Preview/index';

import { uniqueId } from 'lodash';

import { FaUpload } from 'react-icons/fa';

import { decodeHexHtmlCharCodes } from '../../../services/utils';
import { ModalError } from '../../ModalError';

const FileList = ({ onPodeConfirmarEnvio = valor => {}, tipos_arquivos_aceitos = null, nomeCampo, labelCampo, propsForm, remove, requerido, msgErroObrigatorio = '' }) => {
    const [uploadedFiles, setUploadedFiles] = useState([]);

    const inputAcceptsFiles = tipos_arquivos_aceitos ?? '.jpg,.png,.jfif,.jpeg,.pdf';

    const updateFile = (key, data) => {
        setUploadedFiles(state =>
            state.map(file => {
                return key === file.key ? { ...file, ...data } : file;
            })
        );
    };

    const sendFile = file => {
        const data = new FormData();
        data.append('file', file.file);

        FURGAPI.upload(data)
            .then(resposta => {
                updateFile(file.key, { uploaded: true, key: resposta.key });
            })
            .catch(err => {
                updateFile(file.key, { uploaded: false, error: decodeHexHtmlCharCodes(err) });
            });
    };

    const handleChangeFile = e => {
        onPodeConfirmarEnvio(false);

        const files = e?.target?.files;
        if (null !== files) {
            const uploadFiles = [...files].map(file => ({
                file,
                key: uniqueId(),
                preview: URL.createObjectURL(file),
                uploaded: false,
                error: false,
                url: null,
                errorShowed: false,
            }));

            setUploadedFiles(state => [...state, ...uploadFiles]);

            uploadFiles.forEach(file => {
                sendFile(file);
            });
        }
        e.target.value = '';
    };

    const handleRemove = key => {
        setUploadedFiles(state => {
            state.forEach((arquivo, index) => {
                propsForm.unregister(`${nomeCampo}[${index}].chave`);
                propsForm.unregister(`${nomeCampo}[${index}].extensao`);
            });
            return state.filter(file => {
                return key !== file.key;
            });
        });
    };

    const obtemArquivosEnviadosComErro = uploadedFiles.filter(file => !file.uploaded && file.error !== false && !file.errorShowed);

    const obtemQtdArquivosEnviadosComSucesso = () => uploadedFiles.filter(file => file.uploaded).length;

    useEffect(() => {
        const totalArquivosEnviadosComSucesso = uploadedFiles.filter(file => file.uploaded).length;
        const totalArquivosEnviadosComErro = uploadedFiles.filter(file => !file.uploaded && file.error !== false).length;
        const validouUpload = 0 === uploadedFiles.length - totalArquivosEnviadosComSucesso - totalArquivosEnviadosComErro;

        validouUpload && onPodeConfirmarEnvio && onPodeConfirmarEnvio(true);
    }, [uploadedFiles, onPodeConfirmarEnvio]);

    return (
        <div className={'form-label-group' + (requerido ? ' required' : '') + (uploadedFiles.length === 0 && msgErroObrigatorio ? ' destaque' : '')}>
            <label>{labelCampo}</label>
            <span className="text-muted d-flex">{obtemQtdArquivosEnviadosComSucesso()} documento(s) enviado(s)</span>

            {obtemArquivosEnviadosComErro.length > 0 && (
                <ModalError onClose={() => obtemArquivosEnviadosComErro.map(arquivo => updateFile(arquivo.key, { errorShowed: true }))}>
                    <ul>
                        {obtemArquivosEnviadosComErro.map(arquivo => (
                            <li key={arquivo.key}>
                                Erro: ({arquivo.file.name}): {arquivo.error}
                            </li>
                        ))}
                    </ul>
                </ModalError>
            )}

            <div className="d-flex" style={{ flexWrap: 'wrap' }}>
                {uploadedFiles.map((arquivo, index) => {
                    return <Preview index={index} nomeCampo={nomeCampo} propsForm={propsForm} remove={remove} key={arquivo.key} onRemove={() => handleRemove(arquivo.key)} arquivo={arquivo} />;
                })}
            </div>

            {uploadedFiles.filter(arquivo => arquivo.uploaded).length === 0 && msgErroObrigatorio}

            <div className="d-flex flex-column mt-2">
                <div className="form-group">
                    <label className="btn btn-primary" htmlFor={`enviar_mais_documentos_${nomeCampo}`}>
                        <input id={`enviar_mais_documentos_${nomeCampo}`} type="file" accept={inputAcceptsFiles} multiple className="d-none" onChange={handleChangeFile} />
                        <FaUpload size={14} /> Enviar mais documentos
                    </label>
                </div>
            </div>
        </div>
    );
};
export default FileList;
